import { ESG_PLAN } from '@Domains/Esg/EsgPlan';
import { IESGDetails } from '@Domains/Progress';
import { Box, Typography } from '@mui/material';
import DataPlatformSection from './ESGSection/DataPlatformSection';
import GreenhouseSection from './ESGSection/GreenhouseSection';
import SelectESG from './SelcectESG';

type ESGProgressProps = {
  esg?: IESGDetails;
  reportId?: number;
  isPublished: boolean;
};

const ESGProgress = ({ esg, reportId, isPublished }: ESGProgressProps) => {
  if (!esg) return null;

  if (esg.characteristicTypes === null) {
    return (
      <Box p={1}>
        <Typography fontWeight="bold" ml={2}>
          แผนการยกระดับ ESG
        </Typography>
        <SelectESG reportId={reportId} />
      </Box>
    );
  }

  return (
    <Box p={1}>
      <Typography fontWeight="bold" ml={2}>
        แผนการยกระดับ ESG
      </Typography>
      {esg.characteristicTypes.includes(ESG_PLAN.DATA_PLATFORM) && (
        <DataPlatformSection
          esg={esg}
          reportId={reportId}
          isPublished={isPublished}
        />
      )}
      {esg.characteristicTypes.includes(ESG_PLAN.GREEN_HOUSE) && (
        <GreenhouseSection
          esg={esg}
          reportId={reportId}
          isPublished={isPublished}
        />
      )}
    </Box>
  );
};

export default ESGProgress;
